module.exports = __webpack_public_path__ + "img/booking-level-white-icon.e09aa6f7.svg";